export default __webpack_public_path__ + "static/filepicker-177433f290e13feea03083309593983f.png";